import React from 'react';
import { Box, TextField, Button, Typography, InputAdornment } from '@mui/material';
import { styled } from '@mui/system';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SubjectIcon from '@mui/icons-material/Subject';
import SendIcon from '@mui/icons-material/Send';

const ContactContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: '50px',
  gap: '20px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column', // Stack form and address vertically for small screens
    alignItems: 'center',
  },
}));

const ContactForm = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  [theme.breakpoints.down('sm')]: {
    width: '100%', // Full width for small screens
  },
}));

const ContactDetails = styled(Box)(({ theme }) => ({
  flex: 1,
  paddingLeft: '20px',
  marginTop: '30px', // Add spacing to align with the form
  [theme.breakpoints.down('sm')]: {
    paddingLeft: '0', // Remove padding for small screens
    textAlign: 'center',
    marginTop: '20px', // Adjust spacing for small screens
  },
}));

const ContactDetailItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '20px', // Add consistent spacing between details
}));

function ContactUs() {
  return (
    <ContactContainer id="contact-us">
      {/* Contact Form */}
      <ContactForm component="form">
        <Typography variant="h4" gutterBottom>
          Get in Touch
        </Typography>
        <TextField
          label="Your Name"
          variant="outlined"
          fullWidth
          required
        />
        <TextField
          label="Your Email"
          variant="outlined"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailIcon />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Contact"
          variant="outlined"
          fullWidth
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PhoneIcon />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Message"
          variant="outlined"
          fullWidth
          multiline
          rows={4}
          required
        />
        <Button
          variant="contained"
          color="primary"
          type="submit"
          endIcon={<SendIcon />}
        >
          Send Message
        </Button>
      </ContactForm>

      {/* Contact Details */}
      <ContactDetails>
        <Typography variant="h4" gutterBottom>
          Contact Information
        </Typography>
        <ContactDetailItem>
          <LocationOnIcon style={{ marginRight: '10px' }} />
          <Typography variant="body1">
            <strong>Adresse:</strong> Cité Minière, Route le Prince, Commune de Dixinn, République de Guinée
          </Typography>
        </ContactDetailItem>
        <ContactDetailItem>
          <PhoneIcon style={{ marginRight: '10px' }} />
          <Typography variant="body1">
            <strong>Phone:</strong> +224 621 238 262 / +224 628 387 502
          </Typography>
        </ContactDetailItem>
        <ContactDetailItem>
          <EmailIcon style={{ marginRight: '10px' }} />
          <Typography variant="body1">
            <strong>Email:</strong> benkhalilrc.lng@gmail.com / wodia1982@gmail.com
          </Typography>
        </ContactDetailItem>
        <ContactDetailItem>
          <AccessTimeIcon style={{ marginRight: '10px' }} />
          <Typography variant="body1">
            <strong>Horaire de Travail:</strong> Lun - Vend 8:00 - 17:00
          </Typography>
        </ContactDetailItem>
      </ContactDetails>
    </ContactContainer>
  );
}

export default ContactUs;